/**
 * @generated SignedSource<<bc54717760e4284a89d9eb874187ee2b>>
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import type { Fragment, ReaderFragment } from 'relay-runtime';
export type JiraNavigationItemTypeKey = "APP" | "APPROVALS" | "APPS" | "ARCHIVED_ISSUES" | "ATTACHMENTS" | "BACKLOG" | "BOARD" | "CALENDAR" | "CAPACITY" | "CODE" | "COMPONENTS" | "CUSTOMER_SUPPORT" | "DEPENDENCIES" | "DEPLOYMENTS" | "DEVELOPMENT" | "FORMS" | "GET_STARTED" | "GOALS" | "INBOX" | "INCIDENTS" | "ISSUES" | "LIST" | "ON_CALL" | "PAGES" | "PLAN_CALENDAR" | "PLAN_DEPENDENCIES" | "PLAN_PROGRAM" | "PLAN_RELEASES" | "PLAN_SUMMARY" | "PLAN_TEAMS" | "PLAN_TIMELINE" | "PROGRAM" | "QUEUE" | "RELEASES" | "REPORTS" | "REQUESTS" | "SECURITY" | "SHORTCUTS" | "STAFFING" | "SUMMARY" | "TEAMS" | "TIMELINE" | "%future added value";
import type { FragmentRefs } from "relay-runtime";
export type NavigationItemTab_tab$data = {
  readonly __typename: string;
  readonly typeKey: JiraNavigationItemTypeKey;
  readonly url: string | null | undefined;
  readonly " $fragmentSpreads": FragmentRefs<"AppTab_tab" | "DefaultTab_tab" | "ShortcutsTab_tab">;
  readonly " $fragmentType": "NavigationItemTab_tab";
};
export type NavigationItemTab_tab$key = {
  readonly " $data"?: NavigationItemTab_tab$data;
  readonly " $fragmentSpreads": FragmentRefs<"NavigationItemTab_tab">;
};

const node: ReaderFragment = {
  "argumentDefinitions": [],
  "kind": "Fragment",
  "name": "NavigationItemTab_tab",
  "selections": [
    {
      "kind": "ScalarField",
      "name": "__typename"
    },
    {
      "kind": "RequiredField",
      "field": {
        "kind": "ScalarField",
        "name": "typeKey"
      },
      "action": "THROW",
      "path": "typeKey"
    },
    {
      "kind": "ScalarField",
      "name": "url"
    },
    {
      "kind": "FragmentSpread",
      "name": "DefaultTab_tab"
    },
    {
      "kind": "FragmentSpread",
      "name": "ShortcutsTab_tab"
    },
    {
      "kind": "FragmentSpread",
      "name": "AppTab_tab"
    }
  ],
  "type": "JiraNavigationItem",
  "abstractKey": "__isJiraNavigationItem"
};

(node as any).hash = "751fa7ab98212b17632e93d1c53dfc75";

export default node;
